import STGradianSlider from 'common/STGradianSlider/STGradianSlider';
import useTokenUsageSlider from './useTokenUsageSlider';
import { Box, Typography } from '@mui/material';
import { saasModernTheme } from 'common/theme/saasModern';
import { sliderPositionToValue,valueToSliderPosition } from 'utils/formatSliderPricing';

const TokenUsageSlider = ({ subPlansTokenUsage, value, onChange }) => {
  const { marks, minValue, maxValue, step } = useTokenUsageSlider({
    subPlansTokenUsage,
    value,
    handleTokenUsageChange: onChange,
  });

  const onChangeSlider = (event, newValue ) => {
    onChange(event, sliderPositionToValue(newValue));
  };

  const renderLabel = (label) => (
    <Typography
    
        fontWeight="500"
      sx={{
        fontSize:['12px','16px'],
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        color: '#888C93',
      }}
    >
      {label}
    </Typography>
  );

  return (
    <Box
      sx={{
        width: '90%',
        marginInline: 'auto',
        my: '40px',
      }} 
    >
      <STGradianSlider
        value={valueToSliderPosition(value)}
        onChange={onChangeSlider}
        min={valueToSliderPosition(minValue)}
        max={valueToSliderPosition(maxValue)}
        step={0.01}
        scale={sliderPositionToValue}
        valueLabelDisplay="on"
        aria-labelledby="non-linear-slider"
        marks={marks?.map((mark) => ({
          value: valueToSliderPosition(mark.value),
          label: mark.label ? renderLabel(mark.label) : undefined,
        }))}
      />
    </Box>
  );
};

export default TokenUsageSlider;
